import React from 'react';
import useStyle from './avatarPagination.style';
import KingCrown from 'assets/avatar/categories/king-crown.svg';
import SilverCrown from 'assets/avatar/categories/silver-crown.svg';
import BronzeCrown from 'assets/avatar/categories/bronze-crown.svg';
import HalloweenCrown from 'assets/avatar/categories/halloween.svg';
import { classNames } from '../../../../helpers/style/classNames';

export interface AvatarPaginationProps {
  text: string;
  variant?: 'classic' | 'bronze' | 'silver' | 'gold' | 'halloween';
}

export const AvatarPagination = ({
  text,
  variant = 'classic'
}: AvatarPaginationProps) => {
  const classes = useStyle();

  return (
    <div
      className={classNames(
        [classes.root],
        [
          {
            condition: variant === 'bronze',
            classe: classes.bronze
          },
          {
            condition: variant === 'silver',
            classe: classes.silver
          },
          {
            condition: variant === 'gold',
            classe: classes.gold
          },
          {
            condition: variant === 'halloween',
            classe: classes.halloween
          }
        ]
      )}
    >
      <h4 className={classNames([classes.text])}>{text}</h4>
      {variant !== 'classic' && (
        <img
          src={
            variant === 'bronze'
              ? BronzeCrown
              : variant === 'silver'
              ? SilverCrown
              : variant === 'gold'
              ? KingCrown
              : HalloweenCrown
          }
          alt="Couronne"
        />
      )}
    </div>
  );
};
